import { settingsActionTypes, settingsUris } from './settings-action-types';
import {authorizedRequest} from "../../common/request";
import {applicationHistory} from "../../common/application-history";

export const requestSettings = (dispatch) => {
    console.log('requesting settings');
    settingsRequested(dispatch);
};

export const requestSettingsUpdate = (dispatch, settings) => {
    console.debug('requesting settings update...');
    return settingsUpdateRequested(dispatch, settings); //TODO: Revisit return vs dispatch
};
export const requestWebConfig = (dispatch) => {
    authorizedRequest(
        `${process.env.REACT_APP_WEB_API_URI}/sec/v1/webConfig`
    )
        .then(
            webConfig => {
                dispatch(
                    {
                        type: settingsActionTypes.WEBCONFIG_RECEIVED,
                        webConfig: webConfig
                    }
                )
                if(webConfig.systemProps["system.maintenance"] === true){
                    applicationHistory.push("/my/account/maintenance")
                }
            }
        )
        .catch(error => console.log("Failed to retrieve config settings"));
    return {
        type: "WEBCONFIG_REQUESTED"
    }

}

const settingsRequested = dispatch => {
    fetch(settingsUris.getSettingsUri, {
        credentials: 'same-origin'
    })
    .then(data=> { return data.json() 
        .then(settings=>dispatch(settingsReceived(settings)))
        .catch(error=>dispatch(settingsRequestFailed(error)));
    })
    .catch(error=>dispatch(settingsRequestFailed(error)));

    return {
        type: settingsActionTypes.SETTINGS_REQUESTED
    };
};

const settingsReceived = settings => {
    return {
        type: settingsActionTypes.SETTINGS_RECEIVED,
        settings: settings
    };
};

const settingsRequestFailed = error => {
    return {
        type: settingsActionTypes.SETTINGS_REQUEST_FAILED,
        error: error
    };
};

const settingsUpdateRequested = (dispatch, settings) => {
    fetch(settingsUris.updateSettingsUri, {
        method: 'POST',
        credentials: 'same-origin',
        body: settings
    })
    .then(()=>{dispatch(settingsUpdateSucessful());})
    .catch(error=>dispatch(settingsUpdateFailed(error)));

    return {
        type: settingsActionTypes.SETTINGS_UPDATE_REQUESTED
    };
};

const settingsUpdateSucessful = (dispatch) => {
    //dispatch(requestSettings(dispatch));
    return {
        type: settingsActionTypes.SETTINGS_UPDATE_SUCCESSFUL
    };
};

const settingsUpdateFailed = error => {
    return {
        type: settingsActionTypes.SETTINGS_UPDATE_FAILED,
        error: error
    };
};


// WEBPACK FOOTER //
// ./src/settings/actions/customer-settings-actions.js